// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecordingPlaceholder__container-fb62ef {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-inline-start: 8px;
  padding-inline-end: 12px;
  background: rgba(51, 51, 51, 0.7);
  border-radius: 24px;
}

.RecordingPlaceholder__container-fb62ef:hover,
.RecordingPlaceholder__container-fb62ef:focus-visible {
  cursor: pointer;
  background: rgba(51, 51, 51, 0.8);
}

.RecordingPlaceholder__container-fb62ef:active {
  background: rgba(51, 51, 51, 0.9);
}

.RecordingPlaceholder__icon-e10eb6 {
  width: 10px;
  height: 10px;
  background-color: var(--brand-primary-40);
  border-radius: 50%;
  animation-name: RecordingPlaceholder__blink-be2da0;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

.RecordingPlaceholder__title-c3b283 {
  font: var(--font-body-4);
  color: var(--addition-50);
  margin-inline-start: 6px;
  text-transform: uppercase;
}

@keyframes RecordingPlaceholder__blink-be2da0 {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/RecordingPlaceholder/RecordingPlaceholder.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,eAAA;EACA,iCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EAEA,kDAAA;EACA,wBAAA;EACA,mCAAA;EACA,yBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;AAAF;;AAGA;EACE;IACE,YAAA;EAAF;EAEA;IACE,UAAA;EAAF;EAEA;IACE,YAAA;EAAF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-inline-start: 8px;\n  padding-inline-end: 12px;\n  background: rgba(51, 51, 51, 0.7);\n  border-radius: 24px;\n}\n\n.container:hover,\n.container:focus-visible {\n  cursor: pointer;\n  background: rgba(51, 51, 51, 0.8);\n}\n\n.container:active {\n  background: rgba(51, 51, 51, 0.9);\n}\n\n.icon {\n  width: 10px;\n  height: 10px;\n  background-color: var(--brand-primary-40);\n  border-radius: 50%;\n\n  animation-name: blink;\n  animation-duration: 1.4s;\n  animation-iteration-count: infinite;\n  animation-fill-mode: both;\n}\n\n.title {\n  font: var(--font-body-4);\n  color: var(--addition-50);\n  margin-inline-start: 6px;\n  text-transform: uppercase;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0.2;\n  }\n  20% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RecordingPlaceholder__container-fb62ef`,
	"icon": `RecordingPlaceholder__icon-e10eb6`,
	"blink": `RecordingPlaceholder__blink-be2da0`,
	"title": `RecordingPlaceholder__title-c3b283`
};
module.exports = ___CSS_LOADER_EXPORT___;
